import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=77ed5500&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/authenticate/_register.scss?vue&type=style&index=0&id=77ed5500&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ed5500",
  null
  
)

export default component.exports